import { transformDateForSend } from '@/utils/form/date'

export function getMapped (formData) {
  return {
    ...transformDateForSend(formData.date)
  }
}
